import React from 'react';
import { Row, Col, Card, Modal, Button, Image } from 'antd';
import './styles.css';

/* const TeamSvg = () => (
  <svg id="SvgjsSvg1017" width="288" height="288" ><defs id="SvgjsDefs1018"></defs><g id="SvgjsG1019" transform="matrix(0.9167,0,0,0.9167,11.995200000000011,11.995200000000011)"><svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 64 64" width="288" height="288"><rect width="6" height="3" x="29" y="51" fill="#1985a1"></rect><path fill="#1985a1" d="M10,42H5.45A2.45,2.45,0,0,1,3,39.55V5.45A2.45,2.45,0,0,1,5.45,3h53.1A2.45,2.45,0,0,1,61,5.45v34.1A2.45,2.45,0,0,1,58.55,42H54"></path><path fill="#1985a1" d="M10,39H8.2A2.14,2.14,0,0,1,6,36.92V8.08A2.14,2.14,0,0,1,8.2,6H55.8A2.14,2.14,0,0,1,58,8.08V36.92A2.14,2.14,0,0,1,55.8,39H54"></path><path fill="#1985a1" d="M10,42H5.45A2.45,2.45,0,0,1,3,39.55V5.45A2.45,2.45,0,0,1,5.45,3h53.1A2.45,2.45,0,0,1,61,5.45v34.1A2.45,2.45,0,0,1,58.55,42H54"></path><path fill="#1985a1" d="M10,39H8.2A2.14,2.14,0,0,1,6,36.92V8.08A2.14,2.14,0,0,1,8.2,6H55.8A2.14,2.14,0,0,1,58,8.08V36.92A2.14,2.14,0,0,1,55.8,39H54"></path><circle cx="32" cy="22" r="10" fill="#ff9f1c"></circle><path d="M16 36a4 4 0 1 1 4-4A4 4 0 0 1 16 36zm0-6a2 2 0 1 0 2 2A2 2 0 0 0 16 30zM19 62H13a1 1 0 0 1-1-1V51H10a1 1 0 0 1-1-1V39.68A2.68 2.68 0 0 1 11.68 37h8.68A2.65 2.65 0 0 1 23 39.64V50a1 1 0 0 1-1 1H20V61A1 1 0 0 1 19 62zm-5-2h4V50a1 1 0 0 1 1-1h2V39.64a.64.64 0 0 0-.64-.64H11.68a.67.67 0 0 0-.68.68V49h2a1 1 0 0 1 1 1z" fill="#000000"></path><path fill="#dcdcdd" d="M19,50V61H13V50H10V39.68A1.68,1.68,0,0,1,11.68,38h8.68A1.65,1.65,0,0,1,22,39.64V50Z"></path><path d="M19 62H13a1 1 0 0 1-1-1V51H10a1 1 0 0 1-1-1V39.68A2.68 2.68 0 0 1 11.68 37h8.68A2.65 2.65 0 0 1 23 39.64V50a1 1 0 0 1-1 1H20V61A1 1 0 0 1 19 62zm-5-2h4V50a1 1 0 0 1 1-1h2V39.64a.64.64 0 0 0-.64-.64H11.68a.67.67 0 0 0-.68.68V49h2a1 1 0 0 1 1 1zM48 36a4 4 0 1 1 4-4A4 4 0 0 1 48 36zm0-6a2 2 0 1 0 2 2A2 2 0 0 0 48 30z" fill="#000000"></path><circle cx="48" cy="32" r="3" fill="#dcdcdd"></circle><path d="M48 36a4 4 0 1 1 4-4A4 4 0 0 1 48 36zm0-6a2 2 0 1 0 2 2A2 2 0 0 0 48 30zM51 62H45a1 1 0 0 1-1-1V51H42a1 1 0 0 1-1-1V39.68A2.68 2.68 0 0 1 43.68 37h8.68A2.65 2.65 0 0 1 55 39.64V50a1 1 0 0 1-1 1H52V61A1 1 0 0 1 51 62zm-5-2h4V50a1 1 0 0 1 1-1h2V39.64a.64.64 0 0 0-.64-.64H43.68a.67.67 0 0 0-.68.68V49h2a1 1 0 0 1 1 1z" fill="#000000"></path><path fill="#dcdcdd" d="M51,50V61H45V50H42V39.68A1.68,1.68,0,0,1,43.68,38h8.68A1.65,1.65,0,0,1,54,39.64V50Z"></path><path d="M51,62H45a1,1,0,0,1-1-1V51H42a1,1,0,0,1-1-1V39.68A2.68,2.68,0,0,1,43.68,37h8.68A2.65,2.65,0,0,1,55,39.64V50a1,1,0,0,1-1,1H52V61A1,1,0,0,1,51,62Zm-5-2h4V50a1,1,0,0,1,1-1h2V39.64a.64.64,0,0,0-.64-.64H43.68a.67.67,0,0,0-.68.68V49h2a1,1,0,0,1,1,1Z" fill="#000000" ></path><rect width="20" height="2" x="22" y="41" fill="#000000"></rect><path d="M58.55,43H54V41h4.55A1.45,1.45,0,0,0,60,39.55V5.45A1.45,1.45,0,0,0,58.55,4H5.45A1.45,1.45,0,0,0,4,5.45v34.1A1.45,1.45,0,0,0,5.45,41H10v2H5.45A3.46,3.46,0,0,1,2,39.55V5.45A3.46,3.46,0,0,1,5.45,2h53.1A3.46,3.46,0,0,1,62,5.45v34.1A3.46,3.46,0,0,1,58.55,43Z" fill="#000000" ></path><rect width="2" height="8" x="31" y="42" fill="#000000"></rect><path d="M35 55H29a1 1 0 0 1-1-1V51a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v3A1 1 0 0 1 35 55zm-5-2h4V52H30zM55.8 40H54V38h1.8A1.14 1.14 0 0 0 57 36.92V8.08A1.14 1.14 0 0 0 55.8 7H8.2A1.14 1.14 0 0 0 7 8.08V36.92A1.14 1.14 0 0 0 8.2 38H10v2H8.2A3.15 3.15 0 0 1 5 36.92V8.08A3.15 3.15 0 0 1 8.2 5H55.8A3.15 3.15 0 0 1 59 8.08V36.92A3.15 3.15 0 0 1 55.8 40z" fill="#000000"></path><path d="M58.55,43H54V41h4.55A1.45,1.45,0,0,0,60,39.55V5.45A1.45,1.45,0,0,0,58.55,4H5.45A1.45,1.45,0,0,0,4,5.45v34.1A1.45,1.45,0,0,0,5.45,41H10v2H5.45A3.46,3.46,0,0,1,2,39.55V5.45A3.46,3.46,0,0,1,5.45,2h53.1A3.46,3.46,0,0,1,62,5.45v34.1A3.46,3.46,0,0,1,58.55,43Z" fill="#000000"></path><path d="M55.8,40H54V38h1.8A1.14,1.14,0,0,0,57,36.92V8.08A1.14,1.14,0,0,0,55.8,7H8.2A1.14,1.14,0,0,0,7,8.08V36.92A1.14,1.14,0,0,0,8.2,38H10v2H8.2A3.15,3.15,0,0,1,5,36.92V8.08A3.15,3.15,0,0,1,8.2,5H55.8A3.15,3.15,0,0,1,59,8.08V36.92A3.15,3.15,0,0,1,55.8,40Z" fill="#000000" ></path><circle cx="16" cy="32" r="3" fill="#dcdcdd"></circle><path d="M16 36a4 4 0 1 1 4-4A4 4 0 0 1 16 36zm0-6a2 2 0 1 0 2 2A2 2 0 0 0 16 30zM32 33A11 11 0 1 1 43 22 11 11 0 0 1 32 33zm0-20a9 9 0 1 0 9 9A9 9 0 0 0 32 13z" fill="#000000"></path><path d="M25.71,25.71l-1.42-1.42,4-4a1,1,0,0,1,1.16-.18l3.27,1.63,1.78-2.22L32.2,20l-.4-2,5-1a1,1,0,0,1,1.05.46,1,1,0,0,1-.07,1.15l-4,5a1,1,0,0,1-1.23.26L29.2,22.22Z" fill="#000000"></path><rect width="2" height="5" x="36" y="18" fill="#000000" ></rect></svg></g></svg>
);
const TeamIcon = () => <Icon component={TeamSvg}  />; */
class DefinitionPage extends React.Component {
  state = {
    modal1Visible: false,
    modal2Visible: false,
    modal3Visible: false,
    modal4Visible: false,

  };

  setModal1Visible(modal1Visible: boolean) {
    this.setState({ modal1Visible });
  }

  setModal2Visible(modal2Visible: boolean) {
    this.setState({ modal2Visible });
  }

  setModal3Visible(modal3Visible: boolean) {
    this.setState({ modal3Visible });
  }

  setModal4Visible(modal4Visible: boolean) {
    this.setState({ modal4Visible });
  }

  handleCancel = () => {
    this.setState({ modal1Visible: false, modal2Visible: false, modal3Visible: false, modal4Visible: false  });
  };
  render() {
    
    return (
  <div className='div-content' style={{ paddingLeft: '2rem'}}>
    <Row gutter={[24, 24]}>
      <Col xs={24} md={12}>
        <Card
          className='card-def'
          cover={
            <img
            alt='Equipo'
            src='\team.svg'
            className='card-img'
          />
          }
        >        
        <Button className='btn-prm' type='primary' onClick={() => this.setModal1Visible(true)} style={{ backgroundColor: '#0181b0', borderColor: '#0181b0', transition: '0.4s' }}>
        ¿Quiénes Somos?
        </Button>
          <Modal
          className='card-modal'
          title='¿Quiénes Somos?'
          visible={this.state.modal1Visible}
          onOk={() => this.setModal1Visible(false)}
          onCancel={() => this.setModal1Visible(false)}
          footer={[
            <Button className='btn-prm' key='back' onClick={this.handleCancel}>
              Volver
            </Button>,
          ]}
          style={{ textAlign: 'center'}}
        >
                <img
                  src='\the-bois.jpeg'
                  alt='Nosotros'
                  className='team-img'
                  style={{   
                      borderRadius: '4px',
                      marginBottom: '25px'
                  }}
                />
              <h3 style={{ fontWeight: 'bold'}}>Nuestro Equipo</h3>
              <p className='paragraph'>
                {'	'}Somos un grupo de estudiantes de la UTP indignados por el
                impune robo de fondos públicos. Somos tres personas que
                entienden que los gobiernos son meros entes administrativos y deben rendir
                cuentas reales a la ciudadanía, por lo que creemos en la transparencia de
                todos los datos públicos tales como los de presupuestos que son nuestro objetivos 
                en este sistema. Fuimos ganadores de la hackathon 2.0 de la UTP bajo la categoría 
                'Transparencia Gubernamental' en la que nos dedicamos idear la plataforma.
              </p>
        </Modal>
        </Card>
      </Col>
      <Col xs={24} md={12}>
        <Card
          className='card-def'
          cover={
            <img
              alt='Patrocinadores'
              src='\sponsors.svg'
              className='card-img'
            />
          }
        >
          <Button className='btn-prm' type='primary' onClick={() => this.setModal2Visible(true)} style={{ backgroundColor: '#0181b0', borderColor: '#0181b0' }}>
          Patrocinadores
        </Button>
          <Modal
          className='card-modal'
          title='Patrocinadores'
          visible={this.state.modal2Visible}
          onOk={() => this.setModal2Visible(false)}
          onCancel={() => this.setModal2Visible(false)}
          footer={[
            <Button className='btn-prm' key='back' onClick={this.handleCancel}>
              Volver
            </Button>,
          ]}
        >
              <div style={{textAlign: 'center'}}>
              <a href='https://www.trustfortheamericas.org/'>
                <img
                  src='\trust-logo.png'
                  alt='Trust for the Americas'
                  // style={{ marginBottom: 15, width: 150 }}
                  className='card-img-logo'
                />
              </a>
              <br />
              <br />
              <a href='https://www.oas.org/es/'>
                <img
                  src='\oea-logo.gif'
                  alt='Organización de los Estados Americanos'
                  // style={{ marginBottom: 15, width: 250 }}

                  className='card-img-logo'
                />
              </a>
              </div>
              <br />
              <h3 style={{ fontWeight: 'bold'}}>¿Que es Trust for the Americas?</h3>
              <p className='paragraph'>
                {'	'}El Trust for the Americas es un afiliado sin fines de lucro
                501 de la Organización de Estados Americanos que trabaja para
                promover el desarrollo económico, social y político en América
                Latina y el Caribe. Establecido en 1997, funciona a través de
                asociaciones públicas y privadas.
              </p>
              <br />
              <h3 style={{ fontWeight: 'bold'}}>Nuestra Misión</h3>
              <p className='paragraph'>
                {'	'}Promover la inclusión social y económica de comunidades
                vulnerables en las Américas a través de alianzas con el sector
                público, privado y sin fines de lucro.
              </p>
              <br />
              <h3 style={{ fontWeight: 'bold'}}>Nuestra Visión</h3>
              <p className='paragraph'>
                {'	'}Contribuir a una región pacífica y justa, donde todos
                encuentren la oportunidad de triunfar y prosperar.
              </p>
              <br />
        </Modal>
        </Card>
      </Col>
    </Row>
    <Row gutter={[24, 24]}>
      <Col xs={24} md={12}>
        <Card
          className='card-def'
          cover={
            <img alt='Motivación' src='\motivation.svg' className='card-img' />
          }
        >
        <Button className='btn-prm' type='primary' onClick={() => this.setModal3Visible(true)} style={{ backgroundColor: '#0181b0', borderColor: '#0181b0' }}>
                  Motivación
        </Button>
          <Modal
          className='card-modal'
          title='Motivación'
          visible={this.state.modal3Visible}
          onOk={() => this.setModal3Visible(false)}
          onCancel={() => this.setModal3Visible(false)}
          footer={[
            <Button className='btn-prm' key='back' onClick={this.handleCancel}>
              Volver
            </Button>,
          ]}
        >
              <h3 style={{ fontWeight: 'bold'}}>Contexto / Problemática</h3>
              <p className='paragraph'>
                {'	'}Actualmente en nuestro país el sistema de registro de 
                transacciones públicas se lleva a cabo por medio de procesos 
                burocráticos y consiste en reportes hechos a mano resultando 
                en recopilaciones de totales sin acceso a las unidades discretas 
                de los gastos e ingresos que supuestamente contribuyeron al total.
              </p>
              <h3 style={{ fontWeight: 'bold'}}>Ejemplo del problema</h3>
              <Image src="\presupuestoda.png"/>
              <br/>
              <br/>
              <p className='paragraph'>
                {'	'}Por ejemplo, la página de{' '}
                <a
                  href='www.datosabiertos.gob.pa'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Datos Abiertos{' '}
                </a>
                nos expone este{' '}
                <a
                  href='https://www.datosabiertos.gob.pa/dataset/f555f97c-cf55-4a69-88a0-0923412ab2b1/resource/943031ac-e7e5-4556-b31c-0b9b61f25d58/download/gastos-agosto2019.pdf'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  recurso
                </a>
                {'. '}
                Analizándolo encontramos que no es más que una lista muy amplía de
                categorías en el eje Y e agregaciones de varios tipos en el eje X. 
                Categorías como 'alquileres', con subcategorías como 'de edificios 
                y locales' que apuntan a 
                <span style={{ fontWeight: 'bold' }}>
                  {' '}
                  un total unitario
                </span>{' '}
                de $206,812.12 como presupuesto ejecutado cuando{' '}
                <span style={{ fontWeight: 'bold' }}>
                  realmente el total es compuesto
                </span>{' '}
                de un número de gastos
                <span style={{ fontWeight: 'bold' }}> unitarios </span>
                por lo que tenemos sumas de gastos representados como gastos 
                unitarios que facilitan el ocultamiento de sobrecostos, coimas
                entre otras actividades.
              </p>
              <Image src="\valorabsolutoda.png"/>
              <br/>
              <br/>
              <p className='paragraph'>
              Un reporte donde '$206,812.12' bajo la categoría de 'Alquileres de 
              edificios y locales' es el mayor nivel de matización, por lo tanto,
               es incapaz de responder preguntas como: ¿Cuáles edificios y locales?,
                ¿Cuánto por cada uno?, etc. Preguntas con respuestas a las cuáles la
                 ciudadanía tiene derecho de conocer; ya que los gobiernos {' '}
                <span style={{ fontWeight: 'bold' }}>
                  meros entes administrativos
                </span>
                , toda información, en lujo de detalle, sobre sus asuntos son propiedad 
                pública. Sin un sistema que permita la repuesta al tipo de preguntas 
                previamente mencionadas, uno, como ciudadano, no puede poner bajo el 
                escrutinio debido a las acciones de los funcionarios públicos en cuanto 
                al gasto nacional; bajo un sistema tan vagamente definido y sin exposición
                de las unidades discretas, la corrupción prospera porque sus actos suceden
                dentro de un contexto de ofuscación sistemática.
              </p>
              <p className='paragraph'>
                Los invitamos a analizar el{' '}
                <a
                  href='https://www.datosabiertos.gob.pa/dataset/f555f97c-cf55-4a69-88a0-0923412ab2b1/resource/943031ac-e7e5-4556-b31c-0b9b61f25d58/download/gastos-agosto2019.pdf'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  recurso
                </a>{' '}
                con el cuál ejemplificamos el problema o cualquier otro de su tipo
                en la página de{' '}
                <a
                  href='www.datosabiertos.gob.pa'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Datos Abiertos{' '}
                </a>{' '}
                y de primera mano verá que no existe un mayor nivel de
                matización en niguna categoría.
              </p>
              <h3 style={{ fontWeight: 'bold'}}>Solución Propuesta</h3>
              <p className='paragraph'>
              La solución no yace en reinventar la rueda o en una idea genial o 
              revolucionaria. Lo que un país necesita para este tipo de sistemas 
              de información es diligencia, orden y acceso directo a la raíz del 
              origen de los datos. Nos gusta describir este tipo de sistemas como 
              'obvios' ya que son necesarios para la organización de una nación de 
              la que todos somos dueños y por ello deberíamos cooperar para que avancemos juntos.
              </p>
              <h4> Con STP proponemos un sistema de información que:</h4>
              <ul>
                <li>
                  Modele gastos, ingresos, presupuestos, entes públicos y la
                  jerarquía entre ellos a nivel{' '}
                  <span style={{ fontWeight: 'bold' }}>discreto</span> (no puedo
                  hacer suficiente énfasis en la importancia de este concepto)
                </li>
                <li>
                Facilitamos la lectura de la información (con particular énfasis en 
                gastos e ingresos) al público general a través de una interface sencilla 
                e intuitiva para la mayoría de los usuarios y trabajaremos en ir mejorándola 
                para alcanzar a llegar a la mente de más personas.
                </li>
                <li>
                También exponemos un API público para que cualquier ente independiente, ya sea
                 particular, empresarial u organización no gubernamental, pueda consultar los
                  datos administrados por el sistema y ser usados, {' '}
                  <span style={{ fontWeight: 'bold' }}>
                    sin justificación alguna al gobierno
                  </span>
                  , para cualquier tipo de escrutinio o transformación,
                  incluidos pero no limitados{' '}
                  <span style={{ fontWeight: 'bold' }}>
                    al reportaje, la presentación y el análisis
                  </span>
                  ; respetando la libre publicación y propiedad sobre dichas
                  transformaciones y escrutinios.
                </li>
              </ul>
        </Modal>
        </Card>
      </Col>
      <Col xs={24} md={12}>
        <Card
          className='card-def'
          cover={
            <img alt='API Público' src='\api.svg' className='card-img' />
          }
        >
                  <Button className='btn-prm' type='primary' onClick={() => this.setModal4Visible(true)} style={{ backgroundColor: '#0181b0', borderColor: '#0181b0' }} >
                  API Público
        </Button>
          <Modal
          className='card-modal'
          title='API Público'
          visible={this.state.modal4Visible}
          onOk={() => this.setModal4Visible(false)}
          onCancel={() => this.setModal4Visible(false)}
          footer={[
            <Button className='btn-prm' key='back' onClick={this.handleCancel}>
              Volver
            </Button>,
          ]}
        >
              <h3 style={{ fontWeight: 'bold'}}>Acceso al API</h3>
              <br />
              <p className='paragraph'>
                Debido a que somos un equipo preocupado por la accesibilidad
                de los datos públicos presentamos un API público para que el
                mismo pueda ser utilizado por cualquier ciudadano con animos de
                explorar los datos financieros públicos y fiscalizar su
                utilización.
              </p>
              <a href='https://documenter.getpostman.com/view/6212290/SVtN3BHm?version=latest'>
                Acceda aquí
              </a>
              <br />
              <br />
              <h3 style={{ fontWeight: 'bold'}}>Definición</h3>
              <p className='paragraph'>
                Una API es un conjunto de definiciones y protocolos que se
                utiliza para desarrollar e integrar el software de las
                aplicaciones. API significa interfaz de programación de
                aplicaciones. Las API permiten que sus productos y servicios se
                comuniquen con otros, sin necesidad de saber cómo están
                implementados. Esto simplifica el desarrollo de las aplicaciones
                y permite ahorrar tiempo y dinero. Las API le otorgan
                flexibilidad; simplifican el diseño, la administración y el uso
                de las aplicaciones, y proporcionan oportunidades de innovación,
                lo cual es ideal al momento de diseñar herramientas y productos
                nuevos (o de gestionar los actuales).
              </p>
        </Modal>
        </Card>
      </Col>
    </Row>
  </div>
)}};

export default DefinitionPage;
        